export default "__VITE_ASSET__jW6xJeQc__"